import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import { useSelector } from 'react-redux';
import type { RootState } from '@/app/store';
import { useAppDispatch } from '@/app/hooks';
import { updateVisualIdentity } from '@/features/workspace/workspaceThunks';
import type {
  WorkspaceVisualIdentity,
  WorkspaceVisualIdentityFontFamily,
} from '@/features/workspace/types';
import type { WorkspaceVisualIdentityInput } from '@/services/workspace.service';
import { useTranslation } from 'react-i18next';

const fontOptions = [
  { value: 'POPPINS', label: 'Poppins', fontFamily: 'Poppins, sans-serif' },
  {
    value: 'GILL_SANS',
    label: 'Gill Sans',
    fontFamily: 'Gill Sans, sans-serif',
  },
  { value: 'UBUNTU', label: 'Ubuntu', fontFamily: 'Ubuntu, sans-serif' },
  { value: 'BITTER', label: 'Bitter', fontFamily: 'Bitter, serif' },
];

export default function VisualTypo({
  visualIdentity,
}: {
  visualIdentity?: WorkspaceVisualIdentity | null;
}) {
  const { t } = useTranslation('webinars');
  const dispatch = useAppDispatch();
  const currentWorkspace = useSelector((state: RootState) => state.workspace.currentWorkspace);

  const handleFontChange = (value: string) => {
    if (!currentWorkspace) return;

    const updatedVisualIdentity = {
      fontFamily: value as WorkspaceVisualIdentityFontFamily,
      theme: visualIdentity?.theme,
      accentColor: visualIdentity?.accentColor,
      backgroundColor: visualIdentity?.backgroundColor,
      secondaryBackgroundColor: visualIdentity?.secondaryBackgroundColor,
      contrastColor: visualIdentity?.contrastColor,
      gradient1Color1: visualIdentity?.gradient1Color1,
      gradient1Color2: visualIdentity?.gradient1Color2,
      gradient2Color1: visualIdentity?.gradient2Color1,
      gradient2Color2: visualIdentity?.gradient2Color2,
    } as WorkspaceVisualIdentityInput;

    dispatch(
      updateVisualIdentity({
        workspaceId: currentWorkspace.id,
        input: updatedVisualIdentity,
      }),
    );
  };

  return (
    <Select value={visualIdentity?.fontFamily as string} onValueChange={handleFontChange}>
      <SelectTrigger
        label={t('visualIdentity.typography.fontFamily')}
        className="border border-input "
      >
        <SelectValue />
      </SelectTrigger>
      <SelectContent>
        {fontOptions.map((font) => (
          <SelectItem key={font.value} value={font.value}>
            <span style={{ fontFamily: font.fontFamily }}>Aa {font.label}</span>
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
